export function formatCommunicationStatus(activity) {
    if (!activity || !['texts', 'faxes'].includes(activity.type)) {
        return null;
    }

    const metadata = activity?.metadata && typeof activity.metadata === 'object'
        ? activity.metadata
        : {};

    const deliveryStatus = typeof metadata.delivery_status === 'string'
        ? metadata.delivery_status.toLowerCase()
        : '';

    if (!deliveryStatus) {
        return null;
    }

    const label = activity.type === 'faxes'
        ? 'Fax'
        : (metadata.communication_channel === 'mms' || metadata.sent_via === 'MMS' ? 'MMS' : 'SMS');

    const formatDateTime = (value) => {
        if (!value) return null;
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return null;
        return date.toLocaleString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
        });
    };

    if (deliveryStatus === 'queued') {
        const queuedUntil = formatDateTime(metadata.queued_until);
        return {
            state: 'queued',
            text: queuedUntil ? `${label} queued until ${queuedUntil}` : `${label} queued`
        };
    }

    if (deliveryStatus === 'confirmation_pending') {
        return {
            state: 'confirmation_pending',
            text: `${label} awaiting provider confirmation; not retried automatically`
        };
    }

    if (deliveryStatus === 'sent') {
        const sentAt = formatDateTime(metadata.sent_at);
        return {
            state: 'sent',
            text: sentAt ? `${label} sent ${sentAt}` : `${label} sent`
        };
    }

    if (deliveryStatus === 'failed') {
        const errorReason = metadata.error_reason ? `: ${metadata.error_reason}` : '';
        return {
            state: 'failed',
            text: `${label} failed${errorReason}`
        };
    }

    return null;
}
